module.exports = __webpack_public_path__ + "img/logo_dark.9383c375.svg";